import { render, staticRenderFns } from "./InfoBoxWarning.vue?vue&type=template&id=4c669726&"
import script from "./InfoBoxWarning.vue?vue&type=script&lang=ts&"
export * from "./InfoBoxWarning.vue?vue&type=script&lang=ts&"
import style0 from "./InfoBoxWarning.vue?vue&type=style&index=0&id=4c669726&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports